import * as step4Const from './constants';

export default {
    [step4Const.getAvoidList](state, avoidListSet) {
        state.avoidListSet = avoidListSet;
    },
    [step4Const.getTagKeysList](state, tagKeySet) {
        state.tagKeySet = tagKeySet;
    },
    [step4Const.getProjects](state, ListProjectResult) {
        state.projectlist = ListProjectResult.ListProjectResult.ProjectList;
        state.projecttotal = ListProjectResult.ListProjectResult.Total
    },
    [step4Const.describeTagValues](state, tagValueSet) {
        state.tagValueSet = tagValueSet;
    },
    [step4Const.getAvoidPackage](state, avoidSet) {
        state.avoidSet = avoidSet;
    },
    [step4Const.createAviod](state, createAvoidSet) {
        state.createAvoidSet = createAvoidSet;
    },
    [step4Const.describeKecIamRoles](state, data) {
        state.describeKecIamRoles = data;
    },
    [step4Const.describeKeys](state, keySet) {
        state.keySet = keySet;
    },
}